import { Modal, ModalProps } from "react-bootstrap";

interface GroupPersonCountMismatchModalProps extends ModalProps {
  onHide: () => void;
  expectedCount: number;
  foundCount: number;
}

const GroupPersonCountMismatchModal = ({
  onHide,
  expectedCount,
  foundCount,
  ...props
}: GroupPersonCountMismatchModalProps) => {
  const expectedLabel = expectedCount === 1 ? "person" : "people";
  const foundLabel = foundCount === 1 ? "person" : "people";

  return (
    <Modal
      {...props}
      onHide={onHide}
      backdrop="static"
      backdropClassName="confirmationModalBackdrop"
      className="mainMenuModal confirmationModal groupPersonCountMismatchModal"
      keyboard={false}
      centered
      scrollable={false}
    >
      <Modal.Body>
        <div className="otpModalBody groupPersonCountMismatchBody">
          <div className="confirmationModalTitle groupPersonCountMismatchTitle">
            Person count doesn&apos;t match
          </div>

          <p className="groupPersonCountMismatchMessage">
            You selected <strong>{expectedCount}</strong> {expectedLabel}, but we found{" "}
            <strong>{foundCount}</strong> {foundLabel} in the photo.
          </p>

          <button
            type="button"
            className="btnYesMenu groupPersonCountMismatchAction"
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              onHide();
            }}
          >
            Try again
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default GroupPersonCountMismatchModal;
